import React from "react";
import { generatePath, Route } from "react-router-dom";
import loadable from "@loadable/component";
import {ResearchPage} from "../pages/ResearchPage";

const HomePage = loadable(() => import("../pages/HomePage"));
const OurTeamPage = loadable(() => import("../pages/OurTeamPage"));
// const ContactPage = loadable(() => import("../pages/ContactPage"));
// const MissionPage = loadable(() => import("../pages/MissionPage"));

export const ROUTES = [
  {
    key: "HomePage",
    path: "/",
    component: HomePage,
    exact: true,
  },
  {
    key: "ResearchPage",
    path: "/research",
    component: ResearchPage,
    exact: true,
  },
  // {
  //   key: "ContactPage",
  //   path: "/contact",
  //   component: ContactPage,
  //   exact: true,
  // },
  // {
  //   key: "MissionPage",
  //   path: "/mission",
  //   component: MissionPage,
  //   exact: true,
  // },
];

export const hrefFor = ROUTES.reduce((acc, route) => {
  return {
    ...acc,
    [route.key]: (params = {}) => generatePath(route.path, params),
  };
}, {});

export const PAGE_ROUTES = ROUTES.map(({ key, path, component, ...rest }) => (
  <Route key={key} path={path} component={component} {...rest} />
));
